module.exports = __webpack_public_path__ + "static/media/KARAN ACOUSTICS MASTER COLLECTION PRE-AMPLIFIER&PSUA.b21e1776.png";